import { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";

import { t } from "../../services";
import { strCode, colors } from "../../consts";

import { LoginPageTemplate } from "../../templates";
import { Input, WrapperContainer, SVG, SmallButton } from "../../components";

const EnterMfa = ({ qrCodeLink, mfa, setMfa, isLoading, hasError, onContinue, onHelpClick }) => {
  const darkMode = useSelector((state) => state.global.darkMode);

  const disabled = useMemo(() => {
    return isLoading || mfa.length !== 6;
  }, [isLoading, mfa]);

  return (
    <LoginPageTemplate
      title={qrCodeLink ? t(strCode.SETUP_MFA_TITLE) : t(strCode.ENTER_MFA_TITLE)}
      description={
        qrCodeLink ? t(strCode.SETUP_MFA_DESCRIPTION) : t(strCode.ENTER_MFA_DESCRIPTION)
      }>
      {qrCodeLink && (
        <QRCode
          bgColor={darkMode ? colors.RAISIN_100 : colors.WHITE}
          fgColor={darkMode ? colors.WHITE : colors.RAISIN_100}
          style={{ margin: "-24px 0 32px 0", backgroundColor: "red" }}
          value={qrCodeLink}
          size={128}
        />
      )}

      <WrapperContainer mb={36}>
        <Input
          id={t(strCode.MFA_CODE_TITLE)}
          title={t(strCode.MFA_CODE_TITLE)}
          value={mfa}
          setValue={setMfa}
          placeholder={t(strCode.MFA_CODE_PLACEHOLDER)}
          maxLength={6}
          type={"number"}
          hasError={hasError}
          icon={onHelpClick && <SVG.InputInfoIcon onClick={() => onHelpClick()} />}
          onKeyDown={(event) => {
            if (event.key === "Enter" && !disabled) {
              onContinue();
            }
          }}
        />
      </WrapperContainer>

      <SmallButton onClick={() => onContinue()} disabled={disabled} loading={isLoading} fullWidth>
        {t(strCode.CONTINUE_BTN)}
      </SmallButton>
    </LoginPageTemplate>
  );
};

EnterMfa.propTypes = {
  qrCodeLink: PropTypes.string,
  mfa: PropTypes.string.isRequired,
  setMfa: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasError: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
  onHelpClick: PropTypes.func
};

export default EnterMfa;
